import Vue from 'vue'
import { BootstrapVue } from 'bootstrap-vue'
import vSelect from 'vue-select'

import './scss/main.scss'
import 'vue-select/dist/vue-select.css'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.component('v-select', vSelect)

Vue.filter('formatNumber', number =>
	number.toLocaleString(undefined, {
		maximumFractionDigits: 2
	})
)
Vue.filter('capitalize', string =>
	string
		.split(' ')
		.map(word => {
			word = word.toLowerCase()
			return word.charAt(0).toUpperCase() + word.slice(1)
		})
		.join(' ')
)
